module.exports = __webpack_public_path__ + "static/media/INSU.f309b50e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/INSU.jpg
// module id = 1757
// module chunks = 1